import React from 'react'

const Sent = () => {
  return (
    <div>Sent</div>
  )
}

export default Sent